import { FC, memo, useEffect, useState } from "react";

import { sendCorrection } from "@/store/reducers/currentData/asyncActionCreators";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { CreateCorrectionPayload } from "@/api/types";
import CorrectionForm from "@/modules/Report/components/CorrectionForm";
import { ICorrection } from "@/models/Correction";

interface CorrectionFormProps {
  readonly: boolean;
}

const Correction: FC<CorrectionFormProps> = ({ readonly }) => {
  const dispatch = useAppDispatch();
  const correction = useAppSelector(
    (state) => state.currentDataReducer.correction
  );
  const [formValues, setFormValues] = useState<ICorrection | null>(null);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (correction) {
      setFormValues(correction);
      setLoading(false);
    }
  }, [correction]);

  const handleSubmit = async (values: { [key: string]: string }) => {
    setLoading(true);
    const correctionPayload: CreateCorrectionPayload = Object.entries(
      values
    ).reduce((sum, [key, value]) => {
      // @ts-ignore
      sum[key] = parseFloat(value);
      return sum;
    }, {} as CreateCorrectionPayload);
    dispatch(sendCorrection(correctionPayload));
  };

  return (
    <CorrectionForm
      values={formValues}
      readonly={readonly}
      loading={loading}
      onSubmit={handleSubmit}
    />
  );
};

export default memo(Correction);
